import { WHITE } from 'reservations/brand/constants';

export const AVAILABILITY_STATUS = {
  CLOSED: 2,
  AVAILABLE: 1,
  UNAVAILABLE: 0
};

// NOTE: This constant is used to denote the Anytime option from the Time dropdown
export const ANYTIME = -1;

export const AVAILABILITIES_INPUT_SX = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: WHITE // Notched outline
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.75)' // Outline on hover
    },
    '& .Mui-focused fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.35)' // Outline on focus
    },
    '& .MuiSvgIcon-root': {
      color: WHITE // Icon color
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)' // Lighter border color when disabled (dropdown empty)
    },
    '&.Mui-disabled .MuiSvgIcon-root': {
      color: 'rgba(255, 255, 255, 0.3)' // Lighter icon color when disabled (dropdown empty)
    }
  },
  '& .MuiInputLabel-root': {
    color: WHITE // Label color
  },
  '& .MuiInputLabel-root .Mui-focused': {
    color: WHITE // Label color on focus
  },
  '& .MuiInputBase-input': {
    color: WHITE // Input text color
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.3)' // Lighter input text color when disabled (dropdown empty)
  }
};

export const AVAILABILITIES_CONTAINER_SX = {
  position: 'relative',
  zIndex: 1,
  backgroundColor: WHITE,
  margin: '0 auto 16px',
  width: '90%',
  padding: '16px 0',
  boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)'
};
